import { render, staticRenderFns } from "./ChatView.vue?vue&type=template&id=e395aafc&scoped=true"
import script from "./ChatView.vue?vue&type=script&lang=js"
export * from "./ChatView.vue?vue&type=script&lang=js"
import style0 from "./ChatView.vue?vue&type=style&index=0&id=e395aafc&prod&lang=css"
import style1 from "./ChatView.vue?vue&type=style&index=1&id=e395aafc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e395aafc",
  null
  
)

export default component.exports